import React from 'react';
import ReactDOM from 'react-dom';

import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import '@fontsource/montserrat';
import '@fontsource/montserrat/500.css';

import 'mapbox-gl/dist/mapbox-gl.css';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';

// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl';

mapboxgl.accessToken = 'pk.eyJ1Ijoib25kcmFuIiwiYSI6ImNsMjZpb3I0bzA1emYza28xM29lNG02c2MifQ.KmCO7QPOf1EHbKnZyBJ_IQ';

const container = document.getElementById('root') as HTMLElement;

if (container.hasChildNodes()) {
  ReactDOM.hydrate(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
    container,
  );
} else {
  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
    container,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
